const Routes = {
  main: '/',
  portfolio: '/portfolio',
  favorites: '/favorites',
  calculator: '/calculator',
  about: '/about',
  login: '/login',
  authLogin: '/authLogin',
  signup: '/signup',
  confirmSignup: '/confirmSignup',
  privacy: '/legal/privacy',
  terms: '/legal/terms',
  settings: '/settings',
  props: '/props',
  logout: '/logout',
  privTest: '/privtest',
  nothing: '/nothing',
};

export default Routes;



// WEBPACK FOOTER //
// ./src/constants/Routes.tsx